module.exports = __webpack_public_path__ + "static/img/iconosVidaSoftware.fbc9eb7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconosVidaSoftware-v1.0/fonts/iconosVidaSoftware.svg
// module id = GFdn
// module chunks = 3